jQuery(document).ready(function($) {
  // Pobierz wszystkie przyciski zakładek i aktywny kontent
  var tabs = document.querySelectorAll('.tab-button');
  var activeContent = document.querySelector('.tab-content');

  // Funkcja do obsługi kliknięć na przyciskach zakładek
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var allButtons = this.closest('.comparison-table__grid').querySelectorAll('.tab-button');
      var target = this.getAttribute('data-target');
      var targetElement = document.getElementById(target);

      // Usuń klasę "active-content" z aktualnie aktywnego kontentu
      activeContent.classList.remove('active-content');
      allButtons.forEach(button => {
        button.classList.remove('comparison-table__grid-cell-logo--active');
      });

      // Dodaj klasę "active-content" do nowego kontentu
      targetElement.classList.add('active-content');
      this.classList.add('comparison-table__grid-cell-logo--active');

      // Ustaw nowy kontent jako aktywny
      activeContent = targetElement;
    });
  });
});
